import { footballBetsStore } from '../footballStore/betStore';
import { footballGameConnection } from '../footballConnection';
import { userInfoStore } from '../../../store/userInfoStore';
import { checkHashStore } from '../../../store/checkHashStore';
import { ValidationType } from '../../../core/constants/validationType';
import { betStatus } from '../../drift/driftCore/constants';
import { footballDrawerService } from './gameDrawerService';
import { betHistoryStore } from '../../../store/betHistoryStore';
import { notificationStore } from '../../../store/notificationStore';
import { soundService } from '../../../services/baseSoundService/soundService';
import { FootballSoundsName } from '../footballCore/constants/sounds';
import { footballHotKeysStore } from '../footballStore/hotKeysStore';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';
import { isMobile } from '../../../core/helpers/isMobile';
import { freeBetStore } from '../../../store/freeBetStore';

class FootballGameService {
  soundInterval = null;

  onGetInitialStateResult({ additionalInfo }) {
    if (additionalInfo) {
      checkHashStore.setLastRoundInfo(additionalInfo);
      checkHashStore.setLastRoundResult({
        cashOutOdd: additionalInfo.odd,
        odd: additionalInfo.odd,
        id: additionalInfo.id,
      });
    }
    this.cancelInvoke();

    setTimeout(() => {
      userInfoStore.getBalance();
    }, 3500);
  }

  doSpin() {
    if (footballBetsStore.isBetsClosed) {
      return;
    }

    if (footballBetsStore.isDoSpinStart) {
      this.sendReportState();
      return;
    }
    footballBetsStore.setIsBetsClosed(true);
    footballDrawerService.playerFirstAnimation();
    soundService.play(FootballSoundsName.bet);
    mainGameConnection.doSpin({ amount: userInfoStore.betAmount });
  }

  sendReportState() {
    this.reportInterval = setInterval(() => {
      if (footballBetsStore.isAllowedNextReportInvoke) {
        footballBetsStore.setIsAllowedNextReportInvoke(false);
        if (document.hasFocus() || isMobile()) {
          footballGameConnection.sendResultReport();
        } else {
          this.sendCashOut();
        }
      }
    }, 100);
  }

  handleDoSpinResult({
    responseCode,
    status,
    balance,
    odd,
    winAmount,
    additionalInfo,
    hash,
    spinId,
  }) {
    if (responseCode === ValidationType.Success) {
      if (!freeBetStore.currentFreeBet) {
        userInfoStore.setUserBalance(balance);
      }
      footballBetsStore.setIsDoSpinStart(true);
      footballBetsStore.setIsAllowedNextReportInvoke(status === betStatus.onHold);
      footballBetsStore.setIsAllowCashOut(status === betStatus.onHold);
      if (status !== betStatus.onHold) {
        clearInterval(this.soundInterval);
        soundService.play(FootballSoundsName.lose);
        footballBetsStore.setIsHeldButton(false);
        checkHashStore.setNextRoundHash(hash);
        checkHashStore.setLastRoundInfo(additionalInfo);
        checkHashStore.setLastRoundResult({
          cashOutOdd: odd,
          id: spinId,
        });

        footballDrawerService.playerFallAnimation(() => {
          footballBetsStore.updateLastResults({ odd, isWin: Boolean(winAmount) });
          setTimeout(() => {
            this.resetGameStore();
          }, 500);
        });
        this.cancelInvoke();
      } else if (footballBetsStore.isHeldButton) {
        this.sendReportState();
      } else {
        this.sendCashOut();
      }
      return null;
    }
    notificationStore.setNotification(responseCode);
    // footballDrawerService.resetAnimations();
    this.resetGameStore();
    clearInterval(this.soundInterval);
    return this.cancelInvoke();
  }

  handleResultReportResult({ responseCode, status, odd, winAmount, hash, additionalInfo, spinId }) {
    if (responseCode === ValidationType.Success) {
      if (status === betStatus.lose) {
        footballBetsStore.setIsHeldButton(false);
        clearInterval(this.soundInterval);
        soundService.play(FootballSoundsName.lose);
        footballBetsStore.setIsAllowCashOut(false);
        footballBetsStore.setGameResult(null);
        footballBetsStore.setCashOutWin(null);
        checkHashStore.setNextRoundHash(hash);
        checkHashStore.setLastRoundInfo(additionalInfo);
        checkHashStore.setLastRoundResult({
          cashOutOdd: odd,
          id: spinId,
        });
        footballDrawerService.playerFallAnimation(() => {
          footballBetsStore.updateLastResults({ odd, isWin: Boolean(winAmount) });
          setTimeout(() => {
            this.resetGameStore();
          }, 1500);
        });
        this.cancelInvoke();
        return null;
      }
      footballBetsStore.setCashOutWin(winAmount);
      footballBetsStore.setGameResult(odd);
      footballBetsStore.setIsAllowedNextReportInvoke(true);
      return null;
    }
    clearInterval(this.soundInterval);
    notificationStore.setNotification(responseCode);
    return this.cancelInvoke();
  }

  handleCashOutResult({
    responseCode,
    additionalInfo,
    hash,
    spinId,
    winAmount,
    cashOutOdd,
    time,
    odd,
  }) {
    if (responseCode === ValidationType.Success) {
      clearInterval(this.soundInterval);
      soundService.play(FootballSoundsName.win);
      footballDrawerService.playerIdleAnimation();
      footballBetsStore.setGameResult(null);
      footballBetsStore.setCashOutWin(null);
      footballHotKeysStore.setIsSpaceHeld(false);
      footballBetsStore.setIsHeldButton(false);
      footballBetsStore.setIsAllowedNextReportInvoke(false);
      footballBetsStore.setWinAmount(winAmount);
      footballBetsStore.setWinOdd(cashOutOdd);
      footballBetsStore.updateLastResults({ odd: cashOutOdd, isWin: Boolean(cashOutOdd) });
      checkHashStore.setNextRoundHash(hash);
      checkHashStore.setLastRoundInfo(additionalInfo);
      checkHashStore.setLastRoundResult({
        id: spinId,
        cashOutOdd: odd,
        time: time,
      });
      setTimeout(() => {
        this.resetGameStore();
      }, 1000);
    } else {
      notificationStore.setNotification(responseCode);
      this.resetGameStore();
    }
  }

  resetGameStore() {
    footballBetsStore.setWinOdd(null);
    footballBetsStore.setWinAmount(null);
    footballBetsStore.setIsDoSpinStart(false);
    footballBetsStore.setIsBetsClosed(false);
    footballDrawerService.playerIdleAnimation();
    betHistoryStore.getLastBet();
    userInfoStore.getBalance();
  }

  sendCashOut() {
    if (footballBetsStore.isAllowCashOut) {
      footballBetsStore.setIsBetsClosed(true);
      footballBetsStore.setIsAllowCashOut(false);
      footballGameConnection.sendCashOut();
    }
  }

  cancelInvoke() {
    clearInterval(this.reportInterval);
  }
}

export const footballGameService = new FootballGameService();
